import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CreditHoldReleaseStatus } from 'src/app/model/credit-hold-release-status.model';
import { AuthService } from 'src/app/services/auth.service';
import { CatComponentService } from 'src/app/services/cat-component.service';

@Component({
  selector: 'app-modal-commission-hold-release',
  templateUrl: './modal-commission-hold-release.component.html',
  styleUrls: ['./modal-commission-hold-release.component.css']
})
export class ModalCommissionHoldReleaseComponent implements OnInit {

  @Input() selectedCommissionHoldRelease: CreditHoldReleaseStatus;
  @Input() catalogoMotivos: any[];
  @Input() figurasRetencion: any[];

  // Inputs para retención por Asesor
  @Input() asesor: any;
  @Input() componente: string;


  public userId = Number(localStorage.getItem('com_token'));

  motivoDescuento: string = '';
  figuraRetencion: string = '';
  comentarios: string = '';
  porcentageDescontar: string = '100';
  userRole: string = '';
  montoComisionField: boolean = false;
  montoRetener: number = null;

  get motivosFiltrados(): any[] {
    return this.catalogoMotivos.filter(m => m.id === 7);
  }
  get figurasRetFiltradas(): any[] {
    return this.figurasRetencion.filter(
      f => f.figura.toUpperCase() === 'ASESOR');
  }

  constructor(
    private toastr: ToastrService,
    private modalService: NgbModal,
    private catComponentService: CatComponentService,
    private auth: AuthService
  ) { }

  ngOnInit() {

    if (this.componente === 'retencion-asesor-comision') {
      console.log("Cargando modal para retención por asesor de comisión ", this.asesor, this.componente);
      const motivoDefault = this.motivosFiltrados[0];
      if (motivoDefault) {
        this.motivoDescuento = motivoDefault.motivo;
        this.porcentageDescontar = motivoDefault.porcentaje || '100';
      }
      if (this.figurasRetFiltradas.length > 0) {
        this.figuraRetencion = this.figurasRetFiltradas[0].figura;
      }
      this.porcentageDescontar = this.asesor.porcentageDescontar != null ? this.asesor.porcentageDescontar : '100';
      this.montoRetener = this.asesor.montoRetener != null ? this.asesor.montoRetener : 0.00;
      this.comentarios = this.asesor.comentarios != null ? this.asesor.comentarios : '';

    } else { // Retención general, se inicializa con los datos del crédito
      console.log("Modal Open", this.selectedCommissionHoldRelease);

      // filtrandomotivoDescuento omitiendo el valor 'ERROR SISTEMA' para evitar confusiones
      this.catalogoMotivos = this.catalogoMotivos.filter(m => m.id !== 7 && m.id !== 8);

      const motivoValido = this.catalogoMotivos
        .find(m => m.motivo === this.selectedCommissionHoldRelease.motivoDescuento);

      const figuraValida = this.figurasRetencion
        .find(f => f.figura === this.selectedCommissionHoldRelease.figuraRetencion);

      // Si no encuentra el valor en el catálogo asigna '' (opción por defecto)
      this.motivoDescuento = motivoValido
        ? this.selectedCommissionHoldRelease.motivoDescuento : '';

      this.figuraRetencion = figuraValida
        ? this.selectedCommissionHoldRelease.figuraRetencion : '';

      this.comentarios = this.selectedCommissionHoldRelease.comentarios != null
        ? this.selectedCommissionHoldRelease.comentarios : '';

      this.porcentageDescontar = this.selectedCommissionHoldRelease.porcentageDescontar != null
        ? this.selectedCommissionHoldRelease.porcentageDescontar : '100';

      this.catComponentService.getElementsForComponent().subscribe((elementGrant) => {
        elementGrant.data
          .filter(el => el.component === "app-commission-hold-release" && this.auth.getUserRoles().includes(el.role))
          .map(el => {
            this.montoComisionField = el.active;
            console.log("montoComisionField: ", this.montoComisionField);
          });
      });
    }
  }

  close = () => {
    this.modalService.dismissAll('failure');
  }

  saveSelectedCommissionHoldRelease = () => {
    if (this.componente === 'retencion-asesor-comision') {
      this.modalService.dismissAll({
        motivoDescuento: this.motivoDescuento,
        figuraRetencion: this.figuraRetencion,
        comentarios: this.comentarios,
        porcentageDescontar: this.porcentageDescontar,
        montoRetener: this.montoRetener,
      });
    } else {
      this.selectedCommissionHoldRelease.motivoDescuento = this.motivoDescuento;
      this.selectedCommissionHoldRelease.figuraRetencion = this.figuraRetencion;
      this.selectedCommissionHoldRelease.comentarios = this.comentarios;
      this.selectedCommissionHoldRelease.porcentageDescontar = this.porcentageDescontar;
      this.modalService.dismissAll(this.selectedCommissionHoldRelease);
    }
  }

  onMotivoChange(motivoSeleccionado: string): void {
    const motivo = this.catalogoMotivos.find(m => m.motivo === motivoSeleccionado);
    if (motivo) {
      this.porcentageDescontar = motivo.porcentaje; // ← campo adicional del catálogo
    } else {
      this.porcentageDescontar = null; // ← limpiar si no hay selección
    }
  }

  validateLenght(): boolean {
    if (!this.motivoDescuento || this.motivoDescuento.length === 0) return false;
    if (!this.figuraRetencion || this.figuraRetencion.length === 0) return false;
    if (!this.comentarios || this.comentarios.length === 0) return false;
    // ← Verificar que no sea null/undefined antes de llamar .length
    if (this.porcentageDescontar === null || this.porcentageDescontar === undefined ||
      String(this.porcentageDescontar).length === 0) return false;
    if (this.componente === 'retencion-asesor-comision' && (!this.montoRetener || this.montoRetener <= 0)) return false;
    return true;
  }

  validateNumber(event: KeyboardEvent) {
    const char = String.fromCharCode(event.which || event.keyCode);
    const input = (event.target as HTMLInputElement).value;

    // ← No permitir más de un punto decimal
    if (char === '.' && input.includes('.')) {
      event.preventDefault();
      return;
    }

    if (!/^[0-9.]$/.test(char)) {
      event.preventDefault();
      this.toastr.warning("El campo solo acepta datos numéricos!");
    }
  }

  validatePorcentaje(): void {
    const val = Number(this.porcentageDescontar);
    if (val > 100) this.porcentageDescontar = '100';
    if (val < 0) this.porcentageDescontar = '0';
  }

  validatePaste(event: ClipboardEvent) {
    const pasteData = event.clipboardData.getData('text');
    if (!/^[0-9.]+$/.test(pasteData)) {
      event.preventDefault();
      this.toastr.warning("El campo solo acepta datos numéricos!");
    }
  }
}